const { PREPROD, GLOBAL } = require('../constant');
const config = require('./config');

module.exports = {
  ...config,
  buildEnv: PREPROD,
  site: GLOBAL,
};
